import { type TEffectList, type TEffectCallback } from '../types/effect';

export class Effect {
  private effectList = new Map<string, TEffectList>();

  effect <T>(callback: TEffectCallback<T>, events: Array<string>, needEventName: boolean = false) {
    events.map(name => {
      const _listenerList = this.effectList.get(name) || [];
      this.effectList.set(name, [..._listenerList, { callback, needEventName }])
    });
  }

  hookEvent (name: string, data: any) {
    const hook = this.effectList.get(name) || [];
    hook.map(v => {
      v.needEventName ? v.callback(data, name) : v.callback(data);
    });
  }
}
